
import {defineComponent} from "vue";
import AlertError2 from "@/components/UI/Bootstrap/Alert/AlertError2.vue";
import {PropType} from "vue/dist/vue";
import {UIStateDto} from "@/dtos/UIStateDto";

export default defineComponent({
  name: "GenericComponentWrapper",
  components: { AlertError2 },
  props: {
    componentUI: {
      type: Object as PropType<UIStateDto>,
      required: true
    },
    /**
     * If set to true, this component does not display the alert error.
     * It is supposed to be handled by the calling component instead.
     */
    hideAlert: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
});
